module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_top_custom_data-8200cc5833d2d0a46d60e3e876ade5ff.png";